/** @format */

import FlightDataActionTypes from './flightData.types';

export const getFlightIdsStart = () => ({
  type: FlightDataActionTypes.GET_FLIGHT_IDS_START,
});

export const getFlightIdsSuccess = (flightIds) => ({
  type: FlightDataActionTypes.GET_FLIGHT_IDS_SUCCESS,
  payload: flightIds,
});

export const getFlightIdsFailure = (error) => ({
  type: FlightDataActionTypes.GET_FLIGHT_IDS_FAILURE,
  payload: error,
});

export const getFlightTimesStart = () => ({
  type: FlightDataActionTypes.GET_FLIGHT_TIMES_START,
});

export const getFlightTimesSuccess = (flightTimes) => ({
  type: FlightDataActionTypes.GET_FLIGHT_TIMES_SUCCESS,
  payload: flightTimes,
});

export const getFlightTimesFailure = (error) => ({
  type: FlightDataActionTypes.GET_FLIGHT_TIMES_FAILURE,
  payload: error,
});

export const getCustomerDataStart = () => ({
  type: FlightDataActionTypes.GET_CUSTOMER_DATA_START,
});

export const getCustomerDataSuccess = (customerData) => ({
  type: FlightDataActionTypes.GET_CUSTOMER_DATA_SUCCESS,
  payload: customerData,
});

export const getCustomerDataFailure = (error) => ({
  type: FlightDataActionTypes.GET_CUSTOMER_DATA_FAILURE,
  payload: error,
});

export const setDof = (dof) => {
  return {
    type: FlightDataActionTypes.SET_DOF,
    payload: dof,
  };
};

export const setCustomerDataLoading = (status) => ({
  type: FlightDataActionTypes.SET_CUSTOMER_DATA_LOADING,
  payload: status,
});

export const setFlightIdsLoading = (status) => ({
  type: FlightDataActionTypes.SET_FLIGHT_ID_LOADING,
  payload: status,
});

export const setSelectedFlightIds = (flightIds) => ({
  type: FlightDataActionTypes.SET_SELECTED_FLIGHT_IDS,
  payload: flightIds,
});

export const setCustomerCount = (count) => ({
  type: FlightDataActionTypes.SET_CUSTOMER_COUNT,
  payload: count,
});

export const setFilteredFlightIds = (flightIds) => ({
  type: FlightDataActionTypes.SET_FILTERED_FLIGHT_IDS,
  payload: flightIds,
});

export const setFilterTimeStart = (start) => ({
  type: FlightDataActionTypes.SET_FILTER_TIME_START,
  payload: start,
});

export const setFilterTimeEnd = (end) => ({
  type: FlightDataActionTypes.SET_FILTER_TIME_END,
  payload: end,
});

export const flightDataReset = () => ({
  type: FlightDataActionTypes.FLIGHT_DATA_RESET,
});
